import { render, staticRenderFns } from "./TabelaResultadosLegislacao.vue?vue&type=template&id=1e0e3cc7&scoped=true"
import script from "./TabelaResultadosLegislacao.vue?vue&type=script&lang=js"
export * from "./TabelaResultadosLegislacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaResultadosLegislacao.vue?vue&type=style&index=0&id=1e0e3cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e3cc7",
  null
  
)

export default component.exports